import React from 'react'
import ReactModal from 'react-modal'
import CloseBtn from '../../buttons/CloseBtn'
import { Form } from 'react-bootstrap'
import RequieredInputs from '../../common/RequiredInputs'

const NewSpecialtiesModal = (
    {
        newSpecialties,
        modalIsOpen,
        closeModal,
        handleSubmit,
        handleChange,
        validateForm,
        textBtn
    }
) => {

    const customStyles = {
        content: {
            width: "60%",
        }
    }

    return (
        <ReactModal
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            contentLabel="Añadir Especialidad"
            className="custom-modal"
            ariaHideApp={false}
            style={customStyles}
        >
            <span className="custom-modal__close close-btn" onClick={closeModal}><CloseBtn /></span>
            <h4 className="custom-modal__title">Añadir nueva especialidad</h4>
            <Form onSubmit={handleSubmit} className="products__form">
                <Form.Group controlId="product-name">
                    <Form.Label className="form__labels">Especialidad <RequieredInputs/> </Form.Label>
                    <Form.Control className="user-input name"
                        type="text"
                        name="nombre"
                        value={newSpecialties.nombre}
                        onChange={handleChange}
                        placeholder="Nombre de la especialidad"
                    />
                </Form.Group>
                <button onClick={handleSubmit} disabled={!validateForm()} className="btn save create">{textBtn}</button>
            </Form>
        </ReactModal>
    )
}
ReactModal.setAppElement('#root')
export default NewSpecialtiesModal